module.exports = __webpack_public_path__ + "img/19.9e870d44.svg";